import { Component, OnInit, Output, EventEmitter, ViewChildren, Input } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FiltersService } from '../../services';
import * as _ from 'lodash';

@Component({
  selector: 'app-maintenance-equipments',
  templateUrl: './maintenance-equipments.component.html',
  styleUrls: ['./maintenance-equipments.component.scss']
})
export class MaintenanceEquipmentsComponent implements OnInit {
  @Output() relationshipsOutput = new EventEmitter();

  @Input() relationships = [
    {
      cdArea: "",
      dsArea: "",
      equipamentos: []
    }
  ];

  @ViewChildren('autocompleteEquipments') autocompleteEquipments;

  autocompleteDataEquipments;

  placeHolder = "Pesquisar";
  notFoundText = "Sem resultados";
  searchKeywordEquipments = "dsProduto";
  selectedEquipments = [];

  areas;

  constructor(
    private filtersService: FiltersService,
    private loadingBarService: LoadingBarService
  ) { }

  ngOnInit() {
    this.listAreas();

    this.listEquipments();
  }

  resetQuery() {
    this.autocompleteEquipments.forEach((autocomplete) => {
      autocomplete.query = "";
    });
  }

  listAreas() {
    this.areas = [];

    this.filtersService.listAreas().subscribe((response) => {
      this.areas = response['data'];
    });
  }

  listEquipments() {
    this.autocompleteDataEquipments = [];

    this.filtersService.listEquipments().subscribe((response) => {
      this.autocompleteDataEquipments = response['data'];
    });
  }

  addRelationship() {
    this.relationships.push({
      cdArea: "",
      dsArea: "",
      equipamentos: []
    });
  }

  removeRelationship(index) {
    this.relationships.splice(index, 1);
  }

  addEquipment(index, item) {
    this.relationships[index].equipamentos.push(item);

    this.resetQuery();
  }

  dsArea(index, value) {
    if (value) {
      let filtered = _.filter(this.areas, function(area) {
        return area.cdArea == value;
      });

      this.relationships[index].dsArea = filtered[0].dsArea;
    } else {
      this.relationships[index].cdArea = "";

      this.relationships[index].dsArea = "";
    }
  }

  onSelectEquipments(index, item) {
    this.removeEquipments(index, item);

    this.addEquipment(index, item);
  }

  removeEquipments(index, item) {
    _.remove(this.relationships[index].equipamentos, function(n) {
      return n.cdProduto == item.cdProduto;
    });
  }

  outputRelationships() {
    this.relationshipsOutput.emit(this.relationships);
  }

}
